import React from 'react'
import Slider from 'react-fast-marquee';
import "./Marque2.css"
import vid1 from '../../assests/videos/video1.mp4'
import vid5 from '../../assests/videos/video5.mp4'
import vid3 from '../../assests/videos/video3.mp4'
import vid4 from '../../assests/videos/video4.mp4'
import vid7 from'../../assests/videos/video7.mp4'
import Video from './Video/Video';


const Marquee2 = () => {
  return (
    <div className='Marquee2Holder'>
    <Slider className="marquee" autofill ={true} pauseOnHover={false} direction='left'  speed ={60}>
      <Video video = {vid1}></Video>
      <h3>Figma <br></br> <span> over Fear</span></h3>
      <Video video = {vid7}></Video>
       <h3>Concepts<br></br> <span>become code</span></h3>
      <Video video = {vid5}></Video>
       <h3>Intuition +<br></br> <span>Innovation</span></h3>
      <Video video = {vid3}></Video>
       <h3>Digital <br></br> <span>Manifestation</span></h3>
      <Video video = {vid4}></Video>
       <h3>Design<br></br> <span>Then conquer</span></h3>
       
    </Slider>
   
        
    </div>
  )
}

export default Marquee2 